<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
    <circle cx="40" cy="40" r="33.3333" fill="#F2BA00" stroke="#FA7E25" stroke-width="3.33333" />
    <path
      d="M31.6667 54.1654C31.6667 57.387 29.055 59.9987 25.8333 59.9987C22.6117 59.9987 20 57.387 20 54.1654C20 51.6098 23.6705 46.2919 25.1884 44.2021C25.5106 43.7584 26.1561 43.7584 26.4783 44.2021C27.9961 46.2919 31.6667 51.6098 31.6667 54.1654Z"
      fill="#00BDFC"
    />
    <rect x="23.3359" y="31.668" width="10" height="13.3333" rx="5" fill="#813612" />
    <rect x="25" y="38.332" width="5" height="5" rx="2.5" fill="white" />
    <rect x="46.6641" y="31.668" width="10" height="13.3333" rx="5" fill="#813612" />
    <rect x="48.3359" y="38.332" width="5" height="5" rx="2.5" fill="white" />
    <path
      d="M35.8359 59.9987C37.0087 58.9498 38.4476 58.332 40.0026 58.332C41.5576 58.332 42.9965 58.9498 44.1693 59.9987"
      stroke="#813612"
      stroke-width="5"
      stroke-linecap="round"
    />
    <circle cx="24.1641" cy="54.168" r="2.5" fill="#D6F5FF" />
  </svg>
</template>
